module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAMAAABFjsb+AAAAJ1BMVEUuMDArLS0uMDAuMDAuMDAuMDAuMDAuMDArLS0uMDAAAAArLS0uMDAiNsLtAAAAC3RSTlMb4AkSeDCWWtcGAEaHSKgAAAA7SURBVHja1cjHAQAgCAQwCxb09p/X9kBhAvOMa5ZcsMc+miNkfQ5AUpfn1fcSlvJc3df5uoKD5MS3NwBR1w4AFdWnMwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/src/assets/img/jquery.datatables/sort_asc.png
// module id = ../../../../../src/assets/img/jquery.datatables/sort_asc.png
// module chunks = 2